import { render } from "./assessmentStarter.vue?vue&type=template&id=5aab3862&scoped=true"
import script from "./assessmentStarter.vue?vue&type=script&lang=js"
export * from "./assessmentStarter.vue?vue&type=script&lang=js"

import "./assessmentStarter.vue?vue&type=style&index=0&id=5aab3862&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_13b2cfeee597e475bd48dd409a32edc8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aab3862"]])

export default __exports__